import { render, staticRenderFns } from "./KCBCertRequest.vue?vue&type=template&id=60e81c69&"
import script from "./KCBCertRequest.vue?vue&type=script&lang=js&"
export * from "./KCBCertRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports